import * as React from 'react';

import WesDesktopNav, {
  type WesDesktopNavProps,
} from 'bundles/composable-page-header-enterprise/main-nav-modules/desktop/WesDesktopNav';
import type { WesMobileNavProps } from 'bundles/composable-page-header-enterprise/module-renderers/WesMobileNav';
import WesMobileNav from 'bundles/composable-page-header-enterprise/module-renderers/WesMobileNav';
import DefaultEnterprisePageHeaderProvider from 'bundles/composable-page-header-enterprise/providers/DefaultEnterprisePageHeaderProvider';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import DefaultMetaNavigation from 'bundles/composable-page-header/components/meta-nav/DefaultMetaNavigation';
import { DEFAULT_META_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

export interface WesPageHeaderProps extends WesMobileNavProps, WesDesktopNavProps {
  /**
   * If true, the meta navigation will be hidden, meta nav is applicable in desktop view only
   */
  hideMetaNav?: boolean;
}

function WesPageHeader(props: WesPageHeaderProps) {
  return (
    <GlobalPageHeaderStateProvider>
      <DefaultEnterprisePageHeaderProvider>
        <GlobalPageHeaderContainer
          desktopMainNav={
            <WesDesktopNav
              renderSearchBar={props.renderSearchBar}
              renderLoggedOutCta={props.renderLoggedOutCta}
              renderHeaderEndContent={props.renderHeaderEndContent}
              logoType={props.logoType}
            />
          }
          mobileMainNav={<WesMobileNav logoType={props.logoType} renderLoggedOutCta={props.renderLoggedOutCta} />}
          metaNav={props.hideMetaNav ? null : <DefaultMetaNavigation />}
          scrollMovementOffset={{
            desktop: props.hideMetaNav ? 0 : DEFAULT_META_NAV_HEIGHT,
            mobile: 0,
          }}
        />
      </DefaultEnterprisePageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
}

export default WesPageHeader;
